import barba from '@barba/core';

$(function () {

    if ($('.module--contactinfo').length) {
        window.initMapbox();
    }

});

barba.hooks.after(() => {
    if ($('.module--contactinfo').length) {
        window.initMapbox();
    }
});
